import * as XLSX from "xlsx";

export default function downloadPayrollExcel(
  payroll,
  companyName = "Muyaz technologies"
) {
  if (!payroll?.items?.length) {
    alert("No payroll data to export");
    return;
  }

  const getComponent = (item, namePart) => {
    const comp = item.components?.find((c) =>
      c.name?.toLowerCase().includes(namePart.toLowerCase())
    );
    return Number(comp?.amount) || 0;
  };

  const money = (value) => {
    const number = Number(value);
    return Number.isFinite(number) ? number : 0;
  };

  const rows = [
    [companyName],
    [
      payroll.description ||
        `${getMonthName(payroll.payrollMonth)} ${payroll.payrollYear} Payroll`,
    ],
    [],
    [
      "S.N",
      "Name",
      "Salary",
      "Position Allowance",
      "Tax free transport allowance",
      "Taxable transport allowance",
      "Gross Salary",
      "Taxable Salary",
      "Tax",
      "Employee Pension",
      "Employer Pension",
      "Total Deductions",
      "Net Salary",
      "Remarks",
    ],
  ];

  const firstDataRow = 5;
  let sn = 1;

  payroll.items.forEach((item) => {
    const basicSalary = getComponent(item, "basic");
    const position = getComponent(item, "position");
    const totalTransport = getComponent(item, "transport");

    const taxFreeTransport =
      totalTransport > 0 ? Math.min(600, totalTransport) : 0;
    const taxableTransport = totalTransport > 600 ? totalTransport - 600 : 0;

    const gross = money(item.grossSalary);
    const taxable = money(item.taxableIncome);
    const tax = money(item.taxAmount);
    const empPension = money(item.employeePension);
    const erPension = money(item.employerPension);

    // Excel formulas are added after creating the worksheet.
    rows.push([
      sn++,
      item.employeeName || "",
      basicSalary,
      position,
      taxFreeTransport,
      taxableTransport,
      gross,
      taxable,
      tax,
      empPension,
      erPension,
      null, // Total Deductions formula
      null, // Net Salary formula
      "",
    ]);
  });

  const lastDataRow = firstDataRow + payroll.items.length - 1;
  const totalRow = lastDataRow + 1;

  rows.push([
    "",
    "Total",
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    "",
  ]);

  rows.push([]);
  rows.push([]);
  rows.push(["Prepared By", "", "", "", "", "", "", "Approved By"]);
  rows.push([
    "Sign _________________________",
    "",
    "",
    "",
    "",
    "",
    "",
    "Sign _________________________",
  ]);
  rows.push([
    "Date _________________________",
    "",
    "",
    "",
    "",
    "",
    "",
    "Date _________________________",
  ]);

  const ws = XLSX.utils.aoa_to_sheet(rows);

  const setFormula = (cell, formula, cachedValue = 0) => {
    ws[cell] = {
      t: "n",
      f: formula,
      v: cachedValue,
      z: "#,##0.00",
    };
  };

  // Per-employee formulas. Excel row numbers are 1-based.
  for (let row = firstDataRow; row <= lastDataRow; row++) {
    setFormula(`L${row}`, `I${row}+J${row}`);
    setFormula(`M${row}`, `G${row}-L${row}`);
  }

  // Totals use formulas, so they update when payroll values change.
  for (const col of ["C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M"]) {
    setFormula(
      `${col}${totalRow}`,
      `SUM(${col}${firstDataRow}:${col}${lastDataRow})`
    );
  }

  // Numeric formatting for salary and allowance columns.
  const amountCols = ["C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M"];

  for (let row = firstDataRow; row <= totalRow; row++) {
    amountCols.forEach((col) => {
      const cell = ws[`${col}${row}`];
      if (cell) cell.z = "#,##0.00";
    });
  }

  ws["!cols"] = [
    { wch: 6 },
    { wch: 28 },
    { wch: 12 },
    { wch: 16 },
    { wch: 22 },
    { wch: 22 },
    { wch: 14 },
    { wch: 14 },
    { wch: 12 },
    { wch: 16 },
    { wch: 16 },
    { wch: 15 },
    { wch: 12 },
    { wch: 12 },
  ];

  // Bold total row (requires a styling-capable XLSX library to render).
  // Standard SheetJS Community Edition does not write cell font styles.

  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Salary");

  const fileName = `Salary_${payroll.payrollMonth}_${payroll.payrollYear}.xlsx`;

  XLSX.writeFile(wb, fileName);
}

function getMonthName(month) {
  const months = [
    "",
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  return months[month] || month;
}
